import React from 'react';
import PageTitle from '../Components/Shared/PageTitle';

const NotFound = () => {
    return (
        <div className='mt-12'>
            <PageTitle title='4 0 4'></PageTitle>
            <img src="https://i.ibb.co/q5F5b5v/404.png" alt="" className="w-full" />
        </div>
    );
};

export default NotFound;